module.exports = __webpack_public_path__ + "img/galaxy-watch-4-1-copy@2x.749a1da0.png";